export default __webpack_public_path__ + "static/media/icon_1.c60636fe.svg";